// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".overlay[data-v-9f396b7a]{z-index:3;position:fixed;top:0;bottom:0;left:0;right:0;background-color:rgba(0,0,0,.5)}[data-v-9f396b7a] #nav-bar-drawer{position:absolute}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
